// Inline email composer (kula_email_compose). Its own envelope, detected
// before the table path.

import type { BlockOutput } from '../../types';
import { arr, str, toId } from './guards';
import type { StructuredEmailCompose } from './types';

export const buildEmailComposeBlock = (
  t: StructuredEmailCompose,
  toolCallId?: string
): BlockOutput | null => {
  const entity = t.entity === 'application' ? 'application' : 'contact';
  const recipients = arr(t.recipients)
    .map((r) => {
      if (typeof r !== 'object' || r === null) return null;
      const obj = r as { id?: unknown; name?: unknown; email?: unknown };
      const id = toId(obj.id) ?? '';
      if (!id) return null;
      return { id, name: str(obj.name), email: str(obj.email) };
    })
    .filter((r): r is NonNullable<typeof r> => r !== null);
  if (recipients.length === 0) return null;
  return {
    type: 'emailCompose',
    data: {
      entity,
      recipients,
      subject: str(t.subject),
      body: str(t.body),
      jobId: toId(t.job_id),
      toolCallId,
      sent: t.sent === true,
    },
  };
};
